<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Select error</h3>
    </div>
  </div>
  <div class="margin-0 card-body navi-hover">
    <div class="kt-margin-bottom-20-mobile">
      <mat-label class="label-radio-button">Error</mat-label>
      <br />
      <br />
      <mat-radio-group [formControl]="control">
        <ng-container *ngFor="let option of errorsOptions">
          <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
          <br />
        </ng-container>
        <mat-error *ngIf="control.hasError('required') && control.touched">
          <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
        </mat-error>
      </mat-radio-group>
    </div>
    <div class="ks-mt-5">
      <mat-form-field appearance="outline" class="mat-form-field-fluid">
        <mat-label>Note</mat-label>
        <textarea matInput [formControl]="note" rows="8"></textarea>
        <mat-error *ngIf="note.hasError('required') && note.touched">
          <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="card-footer" cdkFocusInitial>
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>Cancel</button>

        <button class="mr-2" mat-raised-button color="primary" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</div>
